import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import './WizardTable.css';
import { AppContext } from '../Pages/App';
import { FadeLoader } from 'react-spinners';
import latinize from 'latinize';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import Tooltip from 'rc-tooltip';

// Import React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';

export const navigatePage = () => dispatch => {
  /* do something before redirection */
  console.log('navigating');
  dispatch(push('/wizard'));
};

class WizardTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // data: makeData()
      filter0: 'goals',
      filter1: 'goals',
      filter2: 'goals',
      operator0: 'gt',
      operator1: 'gt',
      operator2: 'gt',
      columns: ['', '', '', '', '', '', '', '', '', '', '', ''],
      position: 'skater',
      season: '20182019',
      players: this.props.players,
      league: 'nhl',
      season_type: '02',
      data: [],
      chosen_columns: [
        'player_name',
        'team',
        'position',
        'age',
        'handedness',
        'height',
        'weight',
        'games_played',
        'goals',
        'assists',
        'points',
        'shots',
        'hits',
        'blocks',
        'plus_minus',
        'toi_per_game'
      ],
      column_selector: false
    };
  }

  handleChange(e, id) {
    /*
      if(e.target.value === "Career") {
          this.setState({season: e.target.value});
      }
      */
    console.log(
      e.target.value,
      id,
      this.state.columns.find(x => x.id == id.toString())
    );
    this.refs.wizardTable.filterColumn(
      this.state.columns.find(x => x.id == id.toString()),
      e.target.value
    );
  }
  changeFilter(e, index) {
    if (index === 0) {
      this.setState({ filter0: e.target.value });
    } else if (index === 1) {
      this.setState({ filter1: e.target.value });
    } else if (index === 2) {
      this.setState({ filter2: e.target.value });
    }
    //console.log(this.state.filter0, this.state.filter1, this.state.filter2);
  }
  changeModifier(e, index) {
    if (index === 0) {
      this.setState({ operator0: e.target.value });
    } else if (index === 1) {
      this.setState({ operator1: e.target.value });
    } else if (index === 2) {
      this.setState({ operator2: e.target.value });
    }
    //console.log(this.state.operator0, this.state.operator1, this.state.operator2);
  }
  sort(e) {
    this.setState({ sorted: [{ id: e.target.value }] });
  }
  toGoalies(e) {
    let goalie_columns = [
      'player_name',
      'team',
      'position',
      'age',
      'gl_starts',
      'gl_wins',
      'gl_loss',
      'gl_otl',
      'gl_shutout',
      'goalie_saves',
      'goalie_shots_faced',
      'sv_pct',
      'goalie_goals_against',
      'gaa',
      'goalie_so_attempts',
      'goalie_so_goal_against',
      'goalie_so_save'
    ];
    let cols = this.getColumns(
      this.state.data.all_columns.filter(x => goalie_columns.includes(x[0])),
      'goalie',
      this.state.league,
      this.state.season,
      this.state.season_type
    );
    let goalies = this.state.data.data.filter(x => x.position === 'G');
    this.setState({
      columns: cols,
      position: 'goalie',
      players: goalies,
      sorted: [{ id: 'gl_wins', desc: true }]
    });
  }
  toSkaters(e) {
    let cols = this.getColumns(
      this.state.data.all_columns.filter(x =>
        this.state.chosen_columns.includes(x[0])
      ),
      'skater',
      this.state.league,
      this.state.season,
      this.state.season_type
    );
    let skaters = this.state.data.data.filter(x => x.position !== 'G');
    this.setState({
      columns: cols,
      position: 'skater',
      players: skaters,
      sorted: [{ id: 'points', desc: true }]
    });
  }

  changeLeague(e) {
    let league = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/contract_central_combined?league=' +
          league +
          '&season=' +
          (this.state.season !== '20182019' ? this.state.season : '20172018') +
          '&season_type=' +
          this.state.season_type,
        requestOptions()
      )
      .then(function(response) {
        let players =
          currentComponent.state.position === 'skater'
            ? response.data.data.filter(x => x.position !== 'G')
            : response.data.data.filter(x => x.position === 'G');
        let id = league === 'nhl' ? '10' : '7';
        let cols = currentComponent.getColumns(
          response.data.all_columns.filter(x =>
            currentComponent.state.chosen_columns.includes(x[0])
          ),
          currentComponent.state.position,
          league,
          currentComponent.state.season,
          currentComponent.state.season_type
        );
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: players,
          position: currentComponent.state.position,
          columns: cols,
          sorted: [{ id: id, desc: true }]
        });
      });
  }

  changeSeason(e) {
    let season = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/contract_central_combined?league=' +
          this.state.league +
          '&season=' +
          season +
          '&season_type=' +
          this.state.season_type,
        requestOptions()
      )
      .then(function(response) {
        let pos =
          currentComponent.state.position === 'skater'
            ? response.data.data.filter(x => x.position !== 'G')
            : response.data.data.filter(x => x.position === 'G');
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: pos
        });
      });
    if (this.state.position === 'goalie') {
      let cols = this.getColumns(
        this.state.data.all_columns.filter(x =>
          this.state.chosen_columns.includes(x[0])
        ),
        this.state.position,
        this.state.league,
        season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        season: season
      });
    } else {
      let cols = this.getColumns(
        this.state.data.all_columns.filter(x =>
          this.state.chosen_columns.includes(x[0])
        ),
        this.state.position,
        this.state.league,
        season,
        this.state.season_type
      );
      this.setState({
        columns: cols,
        season: season
      });
    }
  }
  changeSeasonType(e) {
    let season_type = e.target.value;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/contract_central_combined?league=' +
          this.state.league +
          '&season=' +
          this.state.season +
          '&season_type=' +
          season_type,
        requestOptions()
      )
      .then(function(response) {
        let pos =
          currentComponent.state.position === 'skater'
            ? response.data.data.filter(x => x.position !== 'G')
            : response.data.data.filter(x => x.position === 'G');
        console.log(response.data);
        currentComponent.setState({
          data: response.data,
          players: pos
        });
      });
    if (this.state.position === 'goalie') {
      let cols = this.getColumns(
        this.state.data.all_columns.filter(x =>
          this.state.chosen_columns.includes(x[0])
        ),
        this.state.position,
        this.state.league,
        this.state.season,
        e.target.value
      );
      this.setState({
        columns: cols,
        season_type: e.target.value
      });
    } else {
      let cols = this.getColumns(
        this.state.data.all_columns.filter(x =>
          this.state.chosen_columns.includes(x[0])
        ),
        this.state.position,
        this.state.league,
        this.state.season,
        e.target.value
      );
      this.setState({
        columns: cols,
        season_type: e.target.value
      });
    }
  }

  openExpand(id) {
    console.log('executing expand ', id);
    this.props.dispatch(push('/players?player_id=' + id));
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/contract_central_combined?league=nhl&season=20182019&season_type=02',
        requestOptions()
      )
      .then(function(response) {
        console.log(response.data.data);
        if (response.data) {
          let cols = currentComponent.getColumns(
            response.data.all_columns.filter(x =>
              currentComponent.state.chosen_columns.includes(x[0])
            ),
            'skater',
            'nhl',
            '20182019',
            '02'
          );
          console.log('columns resulting are ' + JSON.stringify(cols));
          currentComponent.setState({
            columns: cols,
            players: response.data.data.filter(x => x.position !== 'G'),
            data: response.data
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  getColumns(cols, position, league, season, season_type) {
    console.log(cols, position, league, season, season_type);
    let currentComponent = this;
    currentComponent.setState({ position: position, league: league });
    let newColumns = [];
    let columns = [];
    for (var i in cols) {
      columns.push(cols[i][0]);
    }
    columns.map((key, value) => {
      console.log(key, value);
      if (key === 'player_name') {
        console.log(JSON.stringify(cols.find(x => x[0] === key)));
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          accessor: d => d[key],
          id: key,
          // currentComponent.state.chosen_columns.indexOf(key).toString(),
          minWidth: 160,
          defaultSortDesc: false,
          filterMethod: (filter, row) => {
            return row[filter.id]
              ? latinize(row[filter.id])
                  .toLowerCase()
                  .includes(filter.value)
              : null;
          }
        });
      } else if (key === 'team' && this.state.season !== 'Career') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => d[key],
          defaultSortDesc: false,
          minWidth: 50
        });
      } else if (key === 'position') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          defaultSortDesc: false,
          accessor: d => d[key],
          minWidth: 50,
          filterMethod: (filter, row) => {
            return row[filter.id] === filter.value;
          }
        });
      } else if (key === 'age') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => d[key],
          defaultSortDesc: false,
          minWidth: 40
        });
      } else if (key === 'games_goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => d[key],
          minWidth: 40
        });
      } else if (key === 'toi_per_game') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a ? +a.split(':')[1] : null;
              let bSecs = b ? +b.split(':')[1] : null;
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          },
          filterMethod: (filter, row) => {
            let a =
              row[filter.id] === null
                ? -Infinity
                : +row[filter.id].split(':')[0];
            if (
              filter.id ===
              this.state.columns.find(x => x.id === this.state.filter0).id
            ) {
              //'28'
              var operator = this.state.operator0;
            } else if (
              filter.id ===
              this.state.columns.find(x => x.id === this.state.filter1).id
            ) {
              var operator = this.state.operator1;
            } else if (
              filter.id ===
              this.state.columns.find(x => x.id === this.state.filter2).id
            ) {
              var operator = this.state.operator2;
            } else {
              return row[filter.id] === filter.value;
            }
            if (operator === '' || operator === 'equals') {
              return a === filter.value ? row[filter.id] : null;
            } else if (operator === 'gt') {
              return a > filter.value ? row[filter.id] : null;
            } else if (operator === 'lt') {
              return a < filter.value ? row[filter.id] : null;
            }
            return 0;
          }
        });
      } else if (key === 'toi') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => d[key],
          minWidth: 65,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a ? +a.split(':')[1] : null;
              let bSecs = b ? +b.split(':')[1] : null;
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          },
          filterMethod: (filter, row) => {
            let a =
              row[filter.id] === null
                ? -Infinity
                : +row[filter.id].split(':')[0];
            if (
              filter.id ===
              this.state.columns.find(x => x.id === this.state.filter0).id
            ) {
              //'28'
              var operator = this.state.operator0;
            } else if (
              filter.id ===
              this.state.columns.find(x => x.id === this.state.filter1).id
            ) {
              var operator = this.state.operator1;
            } else if (
              this.state.columns.find(x => x.id === this.state.filter2).id
            ) {
              var operator = this.state.operator2;
            } else {
              return row[filter.id] === filter.value;
            }
            if (operator === '' || operator === 'equals') {
              return a === filter.value ? row[filter.id] : null;
            } else if (operator === 'gt') {
              return a > filter.value ? row[filter.id] : null;
            } else if (operator === 'lt') {
              return a < filter.value ? row[filter.id] : null;
            }
            return 0;
          }
        });
      } else if (key === 'sv_pct' && position === 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +d[key].toFixed(4) : null),
          minWidth: 60
        });
      } else if (key === 'goalie_so_save_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +d[key].toFixed(4) : null),
          minWidth: 60
        });
      } else if (key === 'gaa' && position === 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          defaultSortDesc: false,
          accessor: d => (d[key] ? +d[key].toFixed(2) : null),
          minWidth: 60
        });
      } else if (key === 'fo_pct' && position !== 'goalie') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0.0),
          minWidth: 50
        });
      } else if (
        key === 'shot_pct' ||
        key === 'corsi_pct' ||
        key === 'corsi_rel' ||
        key === 'fenwick_pct' ||
        key === 'fenwick_rel' ||
        key === 'team_sht_pct_for_oi' ||
        key === 'corsi_rel' ||
        key === 'team_sv_pct_for_oi' ||
        key === 'shot_thru_pct'
      ) {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 50
        });
      } else if (key === 'team_sv_pct_for_oi') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +d[key].toFixed(2) : null),
          minWidth: 50
        });
      } else if (key === 'pdo') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +d[key].toFixed(2) : 0),
          minWidth: 50
        });
      } else if (key === 'oz_starts_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 60
        });
      } else if (key === 'dz_starts_pct') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => (d[key] ? +(d[key] * 100).toFixed(2) : 0),
          minWidth: 60
        });
      } else if (key === 'toi_ev') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          //accessor: d => (d[key] ? d[key].toFixed(2) : null),
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a.split(':')[1];
              let bSecs = b.split(':')[1];
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          }
        });
      } else if (key === 'toi_ev_per_game') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          //accessor: d => (d[key] ? d[key].toFixed(2) : null),
          accessor: d => (d[key] ? d[key] : null),
          minWidth: 60,
          sortMethod: (a, b, desc) => {
            let aMins =
              a === null ? (desc ? -Infinity : Infinity) : +a.split(':')[0];
            let bMins =
              b === null ? (desc ? -Infinity : Infinity) : +b.split(':')[0];
            if (aMins > bMins) {
              return 1;
            } else if (aMins < bMins) {
              return -1;
            } else if (aMins === bMins) {
              let aSecs = a.split(':')[1];
              let bSecs = b.split(':')[1];
              if (aSecs > bSecs) {
                return 1;
              } else if (aSecs < bSecs) {
                return -1;
              }
            }
            return 0;
          }
        });
      } else if (key === 'henri') {
        let cols = [
          {
            Header: 'HENRI',
            id: key,
            accessor: d =>
              d.contracts
                ? d.contracts.find(x => x.season == this.state.season)
                  ? round(
                      d.contracts.find(x => x.season == this.state.season)[key]
                    )
                  : null
                : null,
            minWidth: 60,
            defaultSortDesc: true,
            sortMethod: (a, b, desc) => {
              a =
                a === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : a.split('m').length > 1
                    ? a.split('m')[0] * 1000
                    : a.split('k')[0] * 1;
              b =
                b === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : b.split('m').length > 1
                    ? b.split('m')[0] * 1000
                    : b.split('k')[0] * 1;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            },
            filterMethod: (filter, row) => {
              let a =
                row[filter.id] === null
                  ? -Infinity
                  : row[filter.id].split('m').length > 1
                    ? row[filter.id].split('m')[0] * 1000000
                    : row[filter.id].split('k')[0] * 1000;
              if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter0).id
              ) {
                //'28'
                var operator = this.state.operator0;
              } else if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter1).id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter2).id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return a === filter.value ? row[filter.id] : null;
              } else if (operator === 'gt') {
                return a > filter.value ? row[filter.id] : null;
              } else if (operator === 'lt') {
                return a < filter.value ? row[filter.id] : null;
              }
              return 0;
            }
          }
          /*
          {
            Header: 'H Change',
            id: '29',
            accessor: d =>
              d.stats.find(
                x => x.year === season && x.season_type === season_type
              ) &&
              d.stats.find(
                x =>
                  x.year === (season - 10001).toString() &&
                  x.season_type === season_type
              )
                ? d.stats.find(
                    x => x.year === season && x.season_type === season_type
                  )[key] &&
                  d.stats.find(
                    x =>
                      x.year === (season - 10001).toString() &&
                      x.season_type === season_type
                  )[key]
                  ? round(
                      d.stats.find(
                        x => x.year === season && x.season_type === season_type
                      )[key] -
                        d.stats.find(
                          x =>
                            x.year === (season - 10001).toString() &&
                            x.season_type === season_type
                        )[key]
                    )
                  : null
                : null,
            minWidth: 60,
            defaultSortDesc: true,
            sortMethod: (a, b, desc) => {
              a =
                a === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : a.split('m').length > 1
                    ? a.split('m')[0] * 1000
                    : a.split('k')[0] * 1;
              b =
                b === null
                  ? desc
                    ? -Infinity
                    : Infinity
                  : b.split('m').length > 1
                    ? b.split('m')[0] * 1000
                    : b.split('k')[0] * 1;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            },
            filterMethod: (filter, row) => {
              let a =
                row[filter.id] === null
                  ? -Infinity
                  : row[filter.id].split('m').length > 1
                    ? row[filter.id].split('m')[0] * 1000000
                    : row[filter.id].split('k')[0] * 1000;
              if (filter.id === this.state.columns[this.state.filter0].id) {
                //'28'
                var operator = this.state.operator0;
              } else if (
                filter.id === this.state.columns[this.state.filter1].id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id === this.state.columns[this.state.filter2].id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return a === filter.value ? row[filter.id] : null;
              } else if (operator === 'gt') {
                return a > filter.value ? row[filter.id] : null;
              } else if (operator === 'lt') {
                return a < filter.value ? row[filter.id] : null;
              }
              return 0;
            }
          } */
        ];
        newColumns.push(cols[0]);
      } else if (key === 'aav' || key === 'cap_hit' || key === 'surplus') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d =>
            d.contracts
              ? d.contracts.find(x => x.season == this.state.season)
                ? round(
                    d.contracts.find(x => x.season == this.state.season)[key]
                  )
                : null
              : null,
          minWidth: 50
        });
      } else if (key === 'expiration') {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d =>
            d.contracts.find(x => x.cap_hit === null)
              ? d.contracts
                  .find(x => x.cap_hit === null)
                  .season.toString()
                  .substring(0, 4)
              : d.contracts[d.contracts.length - 1].season
                  .toString()
                  .substring(4),
          minWidth: 50
        });
      } else {
        newColumns.push({
          Header: cols.find(x => x[0] === key)[1],
          id: key,
          accessor: d => d[key],
          minWidth: 50
        });
      }
    });
    return newColumns;
  }

  changeColumns() {
    let column_names = [];
    let checkboxes = document.querySelectorAll('input[type=checkbox]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
      column_names.push(checkboxes[i].value);
    }
    console.log(column_names);
    this.setState({
      chosen_columns: column_names
    });
    let columns = this.getColumns(
      this.state.data.all_columns.filter(x => column_names.includes(x[0])),
      this.state.position,
      this.state.league,
      this.state.season,
      this.state.season_type
    );
    this.setState({
      columns: columns
    });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            color: '#4f738e',
            alignItems: 'center',
            paddingBottom: '1em'
          }}
        >
          <div>
            <div onClick={e => this.toSkaters(e)} className="filterButton">
              <strong>Skaters</strong>
            </div>
            <div onClick={e => this.toGoalies(e)} className="filterButton">
              <strong>Goalies</strong>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <strong>Search:</strong>
              <strong>Season:</strong>
              <strong>League:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ paddingBottom: '1em' }}>
                <input
                  onChange={e => this.handleChange(e, 'player_name')}
                  placeholder={'Search Players'}
                  className="filter"
                />
              </div>
              <div style={{ paddingBottom: '1em' }}>
                <select onChange={e => this.changeSeason(e)} className="filter">
                  {this.state.league === 'nhl' && (
                    <option value="20182019">2018-2019</option>
                  )}
                  <option value="20172018">2017-2018</option>
                  <option value="20162017">2016-2017</option>
                  <option value="20152016">2015-2016</option>
                  <option value="20142015">2014-2015</option>
                  <option value="20132014">2013-2014</option>
                  <option value="20122013">2012-2013</option>
                </select>
              </div>
              <div style={{ paddingBottom: '1em' }}>
                <select onChange={e => this.changeLeague(e)} className="filter">
                  <option value="nhl">NHL</option>
                  <option value="ahl">AHL</option>
                  <option value="shl">SHL</option>
                  <option value="whl">WHL</option>
                  <option value="ohl">OHL</option>
                  <option value="qmjhl">QMJHL</option>
                  <option value="ushl">USHL</option>
                </select>
              </div>
              {/*
                            <div style={{paddingBottom: '1em'}}>
                                <input onChange={(e) => this.handleChange(e, 0)} placeholder={"Enter Date"} className="filter" />
                            </div>

              <div
                onChange={e => this.handleChange(e, 1)}
                style={{ paddingBottom: '1em' }}
              >
                <select
                  onChange={e => this.handleChange(e, 1)}
                  className="filter"
                >
                  <option value="">All</option>
                  <AppContext.Consumer>
                    {context =>
                      context.number.map(item => (
                        <option value={item.abbreviation}>
                          {item.full_team_name}
                        </option>
                      ))
                    }
                  </AppContext.Consumer>
                </select>
              </div>*/}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <strong>Team:</strong>
              <strong>Position:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {this.state.league === 'nhl' && (
                <div>
                  <div
                    onChange={e => this.handleChange(e, 'team')}
                    style={{ paddingBottom: '1em' }}
                  >
                    <select
                      onChange={e => this.handleChange(e, 'team')}
                      className="filter"
                    >
                      <option value="">All</option>
                      <AppContext.Consumer>
                        {context =>
                          context.number.map(item => (
                            <option value={item.abbreviation}>
                              {item.full_team_name}
                            </option>
                          ))
                        }
                      </AppContext.Consumer>
                    </select>
                  </div>
                  <div style={{ paddingBottom: '1em' }}>
                    <select
                      onChange={e => this.handleChange(e, 'position')}
                      className="filter"
                    >
                      <option value="">All</option>
                      <option value="C">C</option>
                      <option value="LW">LW</option>
                      <option value="RW">RW</option>
                      <option value="LD">LD</option>
                      <option value="RD">RD</option>
                      <option value="G">G</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingRight: '1em'
              }}
            >
              <strong className="radioFilters">Handed:</strong>
              <strong className="radioFilters">Season Type:</strong>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                onChange={e => this.handleChange(e, 'handedness')}
                style={{ display: 'flex', paddingBottom: '1em' }}
              >
                <div className="radioButton">
                  <label>ALL</label>
                  <input type="radio" name="handed" value="" />
                </div>
                <div className="radioButton">
                  <label>LH</label>
                  <input type="radio" name="handed" value="L" />
                </div>
                <div className="radioButton">
                  <label>RH</label>
                  <input type="radio" name="handed" value="R" />
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column'
                }}
              >
                <div
                  style={{ display: 'flex', paddingBottom: '1em' }}
                  onChange={e => this.changeSeasonType(e)}
                >
                  <div className="radioButton">
                    <label>Regular</label>
                    <input type="radio" name="season" value="02" />
                  </div>
                  <div className="radioButton">
                    <label>Playoffs</label>
                    <input type="radio" name="season" value="03" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <strong style={{ padding: 0 }}>Filter Results By:</strong>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 0)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.all_columns &&
                  this.state.chosen_columns.map(value => (
                    <option value={value}>
                      {this.state.data.all_columns.find(x => x[0] === value)[2]}
                    </option>
                  ))}
              </select>
              <select
                onChange={e => this.changeModifier(e, 0)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter0)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 1)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.all_columns &&
                  this.state.chosen_columns.map(value => (
                    <option value={value}>
                      {this.state.data.all_columns.find(x => x[0] === value)[2]}
                    </option>
                  ))}
              </select>
              <select
                onChange={e => this.changeModifier(e, 1)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter1)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around'
              }}
            >
              <select
                onChange={e => this.changeFilter(e, 2)}
                className="filter"
                style={{ margin: '0.5em' }}
              >
                {this.state.data.all_columns &&
                  this.state.chosen_columns.map(value => (
                    <option value={value}>
                      {this.state.data.all_columns.find(x => x[0] === value)[2]}
                    </option>
                  ))}
              </select>
              <select
                onChange={e => this.changeModifier(e, 2)}
                className="filter"
                style={{ width: '60px', margin: '0.5em' }}
              >
                <option value="gt">&gt;</option>
                <option value="lt">&lt;</option>
                <option value="equals">=</option>
              </select>
              <input
                onChange={e => this.handleChange(e, this.state.filter2)}
                placeholder={'Number'}
                className="filter"
                style={{ margin: '0.5em' }}
              />
            </div>
          </div>
        </div>
        <div
          className="filterButton"
          style={{ maxWidth: '10em', color: '#4f738e' }}
          onClick={e =>
            this.setState(prevState => ({
              column_selector: !prevState.column_selector
            }))
          }
        >
          <strong>Choose Columns</strong>
        </div>
        {this.state.column_selector && (
          <div style={{ color: 'white' }}>
            Biographical:
            <input
              type="checkbox"
              name="column"
              value="player_name"
              defaultChecked
            />
            Name
            <input
              type="checkbox"
              name="column"
              value="position"
              defaultChecked
            />
            Position
            <input type="checkbox" name="column" value="age" defaultChecked />
            Age
            <input type="checkbox" name="column" value="team" defaultChecked />
            Team
            <input
              type="checkbox"
              name="column"
              value="handedness"
              defaultChecked
            />
            Handedness
            <input
              type="checkbox"
              name="column"
              value="height"
              defaultChecked
            />
            Height
            <input
              type="checkbox"
              name="column"
              value="weight"
              defaultChecked
            />
            Weight
            <input type="checkbox" name="column" value="draft_year" />
            Draft Year
            <input type="checkbox" name="column" value="draft_round" />
            Draft Round
            <input type="checkbox" name="column" value="draft_overall" />
            Draft Overall
            <input type="checkbox" name="column" value="birthplace" />
            Birthplace
            <br />
            Basic Stats:
            <input
              type="checkbox"
              name="column"
              value="games_played"
              defaultChecked
            />
            GP
            <input type="checkbox" name="column" value="goals" defaultChecked />
            Goals
            <input
              type="checkbox"
              name="column"
              value="assists"
              defaultChecked
            />
            Assists
            <input
              type="checkbox"
              name="column"
              value="points"
              defaultChecked
            />
            Points
            <input type="checkbox" name="column" value="prim_points" />
            Primary Points
            <input type="checkbox" name="column" value="pen_mins" />
            PIM
            <input type="checkbox" name="column" value="shots" defaultChecked />
            Shots
            <input type="checkbox" name="column" value="shots_attempted" />
            Shot Attempts
            <input type="checkbox" name="column" value="toi" />
            TOI
            <input type="checkbox" name="column" value="toi_ev" />
            TOI EV
            <input type="checkbox" name="column" value="fo_wins" />
            Faceoffs Won
            <input type="checkbox" name="column" value="fo_losses" />
            Faceoffs Lost
            <input type="checkbox" name="column" value="hits" defaultChecked />
            Hits
            <input
              type="checkbox"
              name="column"
              value="blocks"
              defaultChecked
            />
            Blocks
            <input
              type="checkbox"
              name="column"
              value="plus_minus"
              defaultChecked
            />
            +/-
            <input type="checkbox" name="column" value="takeaways" />
            Takeaways
            <input type="checkbox" name="column" value="giveaways" />
            Giveaways
            <br />
            Advanced Stats:
            <input type="checkbox" name="column" value="corsi_for" />
            CORSI For
            <input type="checkbox" name="column" value="corsi_agn" />
            CORSI Against
            <input type="checkbox" name="column" value="corsi_pct" />
            CORSI %<input type="checkbox" name="column" value="fenwick_for" />
            Fenwick For
            <input type="checkbox" name="column" value="fenwick_agn" />
            Fenwick Against
            <input type="checkbox" name="column" value="fenwick_pct" />
            Fenwick %<input type="checkbox" name="column" value="oz_starts" />
            OZ Starts
            <input type="checkbox" name="column" value="dz_starts" />
            DZ Starts
            <input type="checkbox" name="column" value="oz_dz_starts" />
            Total OZ/DZ Starts
            <input type="checkbox" name="column" value="total_zone_starts" />
            Total Zone Starts
            <input type="checkbox" name="column" value="goals_for_oi" />
            On-Ice Goals For
            <input type="checkbox" name="column" value="shots_for_oi" />
            On-Ice Shots For
            <input type="checkbox" name="column" value="goals_against_oi" />
            On-Ice Goals Against
            <input type="checkbox" name="column" value="shots_against_oi" />
            On-Ice Shots Against
            <input type="checkbox" name="column" value="goal_game_winning" />
            GWG
            <br />
            {this.state.position === 'goalie' && (
              <div>
                Goalie Stats:
                <input type="checkbox" name="column" value="gl_starts" />
                Starts
                <input type="checkbox" name="column" value="gl_wins" />
                Wins
                <input type="checkbox" name="column" value="gl_loss" />
                Losses
                <input type="checkbox" name="column" value="gl_otl" />
                OTL
                <input type="checkbox" name="column" value="gl_shutout" />
                Shutouts
                <input type="checkbox" name="column" value="goalie_saves" />
                Saves
                <input
                  type="checkbox"
                  name="column"
                  value="goalie_shots_faced"
                />
                Shots Against
                <input type="checkbox" name="column" value="sv_pct" />
                Save %
                <input
                  type="checkbox"
                  name="column"
                  value="goalie_goals_against"
                />
                Goals Against
                <input type="checkbox" name="column" value="gaa" />
                GAA
                <input
                  type="checkbox"
                  name="column"
                  value="goalie_so_attempts"
                />
                SO Attempts
                <input
                  type="checkbox"
                  name="column"
                  value="goalie_so_goal_against"
                />
                SO Goals Against
                <input type="checkbox" name="column" value="goalie_so_save" />
                SO Saves
              </div>
            )}
            Contract Stats:
            <input type="checkbox" name="column" value="expiry_status" />
            Expiry Status
            <input type="checkbox" name="column" value="cap_hit" />
            Cap Hit
            <input type="checkbox" name="column" value="henri" />
            HENRI
            <input type="checkbox" name="column" value="surplus" />
            Surplus
            <input type="checkbox" name="column" value="expiration" />
            Expiration Year
            <br />
            <input
              type="submit"
              value="Change Columns"
              onClick={e => this.changeColumns()}
            />
          </div>
        )}
        {this.state.columns.length > 1 && (
          <ReactTable
            data={this.state.players}
            ref="wizardTable"
            openExpand={this.openExpand}
            defaultFilterMethod={(filter, row) => {
              if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter0).id
              ) {
                var operator = this.state.operator0;
              } else if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter1).id
              ) {
                var operator = this.state.operator1;
              } else if (
                filter.id ===
                this.state.columns.find(x => x.id === this.state.filter2).id
              ) {
                var operator = this.state.operator2;
              } else {
                return row[filter.id] === filter.value;
              }
              if (operator === '' || operator === 'equals') {
                return row[filter.id] === filter.value;
              } else if (operator === 'gt') {
                return row[filter.id] > filter.value;
              } else if (operator === 'lt') {
                return row[filter.id] < filter.value;
              }
            }}
            sorted={this.state.sorted}
            onSortedChange={sorted => {
              this.setState({ sorted });
            }}
            defaultSortDesc={true}
            defaultSorted={[{ id: 'points', desc: true }]}
            defaultSortMethod={(a, b, desc) => {
              a = a === null ? (desc ? -Infinity : Infinity) : a;
              b = b === null ? (desc ? -Infinity : Infinity) : b;
              if (a > b) {
                return 1;
              }
              if (a < b) {
                return -1;
              }
              return 0;
            }}
            getTrProps={(instance, rowInfo) => ({
              onClick: () => {
                this.state.league === 'nhl' &&
                  this.openExpand(instance.data[rowInfo.index].player_id);
              }
            })}
            noDataText={
              <FadeLoader color={'#123abc'} loading={this.state.loading} />
            }
            getNoDataProps={(state, rowInfo, column, instance) => {
              return { style: { background: 'none' } };
            }}
            columns={this.state.columns}
            style={{ minWidth: '95em' }}
            defaultPageSize={30}
            className="-striped -highlight NonRostered WizardTable"
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedWizardTable = connect(mapStateToProps)(WizardTable);
export { connectedWizardTable as WizardTable };



// WEBPACK FOOTER //
// ./src/Components/WizardTable.js